export const RealtimeEventTypes = {
  AppointmentsChanged: "appointments.changed",
  PersonsChanged: "persons.changed",
  CheckinsChanged: "checkins.changed",
  ReaderDevicesStatus: "reader-devices.status",
  ReaderDevicesChanged: "reader-devices.changed",
  ReaderDevicesCommandStatus: "reader-devices.command-status",
  GatewayCommandStatus: "gateway.command-status",
  UscConnectionsChanged: "usc.connections.changed",
  EmailQueueChanged: "email-queue.changed",
  SmsQueueChanged: "sms-queue.changed",
  WhatsAppQueueChanged: "whatsapp-queue.changed",
  InboxChanged: "inbox.changed",
  OutboundMessagesChanged: "outbound-messages.changed",
  LogsChanged: "logs.changed",
  BankStatementTanRequired: "bank-statement.tan-required",
  BankingOperationChanged: "banking.operation-changed",
  BankStatementChanged: "bank-statement.changed",
  CommunicationExecutionsChanged: "communication-executions.changed",
  JobsProgress: "jobs.progress",
  ImportRunsProgress: "import-runs.progress",
  ImportRunsCommitProgress: "import-runs.commit-progress",
  ImportAdapterProgress: "import-adapter.progress",
  TenantBackupsChanged: "tenant-backups.changed",
  TenantDataChanged: "tenant-data.changed",
  AuthorizationChanged: "authorization.changed",
  ProviderPricingChanged: "provider-pricing.changed",
  FailureCircuitsChanged: "failure-circuits.changed",
  ConnectionAttentionChanged: "connection-attention.changed",
  RealtimeTest: "realtime.test"
} as const;
